module.exports = __webpack_public_path__ + "img/q-7-1@2x.14efbbe3.png";